import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./AvantagesNature.module.sass";
import Card from "../../../components/Card";
import DualButton from "../../../components/DualButton";
import Dropdown from "../../../components/Dropdown";
import { getOpcoOptions } from "../../../services/opco.service";

const Specificite = ({ className, data, updateData, validationErrors = {} }) => {
  // Récupérer les données des spécificités
  const specificiteData = data?.contract?.specificite || {};

  // États pour les champs de spécificités
  const [selectedOpco, setSelectedOpco] = useState(null);
  const [opcoOptions, setOpcoOptions] = useState([]);
  const [loadingOpcos, setLoadingOpcos] = useState(true);
  const [dualButton1, setDualButton1] = useState(specificiteData?.dual_button_1 || "Non");
  const [dualButton2, setDualButton2] = useState(specificiteData?.dual_button_2 || "Non");

  // Récupérer les options OPCO au chargement du composant
  useEffect(() => {
    const fetchOpcoOptions = async () => {
      try {
        setLoadingOpcos(true);
        const options = await getOpcoOptions();
        setOpcoOptions(options);
      } catch (error) {
        console.error('Erreur lors de la récupération des OPCO:', error);
        setOpcoOptions([]);
      } finally {
        setLoadingOpcos(false);
      }
    };

    fetchOpcoOptions();
  }, []);

  // Gestionnaire pour les changements de spécificités
  const handleSpecificiteChange = (name, value) => {
    if (updateData) {
      updateData('specificite', { ...data.contract?.specificite, [name]: value });
    }
  };

  // Gestionnaire pour le dropdown OPCO
  const handleOpcoChange = (option) => {
    // Stocker l'objet option complet qui contient value (id) et label (nom)
    setSelectedOpco(option);
    // Sauvegarder l'OPCO dans le folder au lieu du contrat
    if (updateData) {
      updateData('folder', { ...data.folder, opco_id: option.value });
    }
  };

  // Gestionnaire pour les DualButton
  const handleDualButtonChange = (name, value) => {
    if (name === 'dual_button_1') {
      setDualButton1(value);
      // Sauvegarder dans folders avec le nom opco_pays_directly
      if (updateData) {
        updateData('folder', { ...data.folder, opco_pays_directly: value === 'Oui' });
      }
    } else if (name === 'dual_button_2') {
      setDualButton2(value);
      // Sauvegarder dans folders avec le nom mandate_authorization
      if (updateData) {
        updateData('folder', { ...data.folder, mandate_authorization: value === 'Oui' });
      }
    }
  };

  // Effet pour initialiser les données de spécificités
  useEffect(() => {
    // Initialiser l'OPCO depuis le folder
    if (data?.folder?.opco_id && opcoOptions.length > 0) {
      const matchingOpco = opcoOptions.find(option => option.value === data.folder.opco_id);
      setSelectedOpco(matchingOpco || null);
    }
    
    // Initialiser les valeurs depuis le folder
    if (data?.folder) {
      const folder = data.folder;
      
      // Initialiser opco_pays_directly depuis le folder
      if (folder.opco_pays_directly !== undefined) {
        setDualButton1(folder.opco_pays_directly ? "Oui" : "Non");
      }
      
      // Initialiser mandate_authorization depuis le folder
      if (folder.mandate_authorization !== undefined) {
        setDualButton2(folder.mandate_authorization ? "Oui" : "Non");
      }
    }
  }, [data?.folder, opcoOptions]);

  return (
    <>
      <Card className={cn(styles.card, className)} title="Spécificités du contrat" classTitle="title-blue">

        <Dropdown
          className={styles.dropdown}
          label="OPCO"
          placeholder={loadingOpcos ? "Chargement des OPCO..." : "Sélectionner un OPCO"}
          options={opcoOptions}
          value={selectedOpco}
          setValue={handleOpcoChange}
          error={validationErrors.opco_id}
          disabled={loadingOpcos}
        />


        <div className={styles.field}>
          <DualButton
            label="Souhaitez vous que l'OPCO paie directement l'organisme de formation"
            option1="Oui"
            option2="Non"
            value={dualButton1}
            onChange={(value) => handleDualButtonChange('dual_button_1', value)}
            multiSelect={false}
          />
        </div>

        <div className={styles.field}>
          <DualButton
            label="Acceptez-vous de donner le mandat à l'école pour qu'elle s'occupe d'envoyer le contrat d'apprentissage à votre OPCO ?"
            option1="Oui"
            option2="Non"
            value={dualButton2}
            onChange={(value) => handleDualButtonChange('dual_button_2', value)}
            multiSelect={false}
          />
        </div>
      </Card>
    </>
  );
};

export default Specificite;
